import { render } from "./KeeperYear3.vue?vue&type=template&id=d6503930"
import script from "./KeeperYear3.vue?vue&type=script&lang=js"
export * from "./KeeperYear3.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/ff-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__